import { Outlet, useParams } from "react-router-dom";
import { SpaceNav } from "../components/SpaceNav";

/**
 * Every space-scoped screen shares this shell: the nav rail on the left, so
 * getting from one destination to another is one click rather than a trip
 * back through the landing page (issue #41).
 */
export function SpaceLayout() {
  const { spaceId = "" } = useParams();

  return (
    <section className="space-shell">
      <SpaceNav spaceId={spaceId} />
      <div className="space-body">
        <Outlet />
      </div>
    </section>
  );
}
